module.exports = __webpack_public_path__ + "static/media/anker.2200dfc9.svg";